angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-user-factory',
        function ($api, $factory) {
            $api.factory.user = $factory;
        },
    ])
    .factory('graph-user-factory', [
        '$q',
        'graph-api-client',
        'graph-participant-factory',
        'graph-friend-factory',
        'graph-like-factory',
        'graph-document-factory',
        'graph-photo-factory',
        'graph-video-factory',
        'graph-post-factory',
        'graph-search-factory',
        'graph-blacklist-factory',
        '$http',
        function (
            $q,
            client,
            participants,
            friends,
            likes,
            documents,
            photos,
            videos,
            posts,
            search,
            blacklists,
            $http,
        ) {
            var USER = 'user'; // user from slash

            /**
             *  @type {String}
             */
            return {
                uploadUserPhoto: uploadUserPhoto,
                attachHeaderImage: attachHeaderImage,
                disableTfa: disableTfa,

                info: function (id, options) {
                    return client.get([id, 'profile'], options);
                },
                read: function (id, options) {
                    return client.get([id], options);
                },
                privacy: function (data, options) {
                    return client.post(['privacy', 'settings'], data, options);
                },
                privacyList: function (id, options) {
                    return client.get([id, 'privacy', 'settings'], options);
                },
                querySuggestions: function (userId, options) {
                    return client.get([userId, 'suggestions'], options);
                },
                hideSuggestion: function (userId0, userId1, options) {
                    return client.delete([userId0, 'suggestion', userId1], options);
                },
                follow: function (id, options) {
                    return client.post([id, 'following'], options);
                },
                unfollow: function (id, options) {
                    return client.delete([id, 'following'], options);
                },
                update: function (id, data, options) {
                    return client.post([id], data, options);
                },
                delete: function (id, options) {
                    return client.delete([id], options);
                },
                createDeleteRequest: function () {
                    return $http.post('/api/v3.0/user/delete-requests');
                },
                blacklists: function (id) {
                    return blacklists.entry(undefined, id);
                },
                likes: function (id) {
                    return likes.entry(undefined, id);
                },
                friends: function (id) {
                    return friends.entry(undefined, id);
                },
                documents: function (id) {
                    return documents.entry(undefined, id);
                },
                posts: function (id) {
                    return posts.entry(USER, id);
                },
                picture: function (id) {
                    return photos.entry(undefined, id, 'picture');
                },
                cover: function (id) {
                    return photos.entry(undefined, id, 'cover');
                },
                photos: function (id) {
                    return photos.entry(undefined, id, 'photos');
                },
                videos: function (id) {
                    return videos.entry(undefined, id, 'videos');
                },
                search: function (query, options) {
                    return search.entry(USER).search(query, options);
                },
            };

            /**
             * Set given photo as header image of User
             *
             * @param {string|number} userId
             * @param {string|number} photoId
             * @returns {angular.IPromise<object>}
             */
            function attachHeaderImage(userId, photoId) {
                var photosEntryTerm = 'cover';
                var photosEntry = photos.entry(USER, userId, photosEntryTerm);

                return photosEntry.attach(photoId, {}).then(function (response) {
                    return response.data.state === 0 ? response.data.data : $q.reject();
                });
            }

            /**
             * Upload a photo and associate it with a given User ID.
             *
             * Resolves on success with photo entity data.
             * Rejects with upload error message.
             *
             * @param {string|number} userId
             * @param {{name: string, data64: string}} photoData
             * @returns {ng.IPromise}
             */
            function uploadUserPhoto(userId, photoData) {
                // Not important in case of `upload` method. In other cases it changes the called API endpoint.
                var photosEntryTerm = 'photos';
                var photosEntry = photos.entry(USER, userId, photosEntryTerm);
                var uploadData = { name: photoData.name, photo: photoData.data64 };

                return photosEntry.upload(uploadData, {}).then(function (response) {
                    if (response.data.state !== 0) {
                        return $q.reject('The file is too large or the format is incorrect.');
                    }

                    return response.data.data;
                });
            }

            /**
             * Disables tfa for logged in user
             *
             * @param {string|number} userId
             */
            function disableTfa() {
                return client.post(['tfa-disable'], {});
            }
        },
    ]);
